var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section-review",
      class: {
        "bg-color": _vm.bgColor,
        "mini-rev": _vm.typesItem === "mini"
      }
    },
    [
      _c("div", { staticClass: "container" }, [
        "mini" !== _vm.typesItem
          ? _c("div", { staticClass: "row justify-content-center" }, [
              _vm._m(0)
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center" }, [
          _c(
            "div",
            { staticClass: "col-md-11" },
            [
              _c(
                "carousel",
                {
                  attrs: {
                    responsive: _vm.getType(),
                    autoplay: true,
                    dots: true,
                    margin: 30,
                    loop: true
                  }
                },
                [
                  _c("div", { staticClass: "review-item" }, [
                    _c("div", { staticClass: "title-row" }, [
                      _c("div", { staticClass: "img" }, [
                        _c("img", { attrs: { src: "/img/image.png", alt: "" } })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "name" }, [
                        _c(
                          "p",
                          { staticClass: "max p-dgrey relawaySM  mb-0" },
                          [
                            _vm._v(
                              "\n                                    Peter Nordström\n                                "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "rating" }, [
                        _c("div", { staticClass: "star" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "star" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "star" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "star" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "star empty-star" })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _c("p", { staticClass: "min p-dgrey" }, [
                        _vm._v(
                          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor\n                                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco\n                                laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit\n                                esse cillum "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "saved" }, [
                      _c("p", { staticClass: "p-blue min-med  p-bold" }, [
                        _vm._v("Saved 1200 kr/year by comparing")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "verify" }, [
                      _c("p", { staticClass: "p-green2 min" }, [
                        _vm._v("Verifierad köpare "),
                        _c("img", {
                          attrs: { src: "/img/icon/submit.svg", alt: "" }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "review-item" }, [
                    _c("div", { staticClass: "title-row" }, [
                      _c("div", { staticClass: "name" }, [
                        _c(
                          "p",
                          { staticClass: "max p-dgrey relawaySM  mb-0" },
                          [
                            _vm._v(
                              "\n                                    Peter Nordström\n                                "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "rating" }, [
                        _c("div", { staticClass: "star" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "star" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "star" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "star" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "star empty-star" })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _c("p", { staticClass: "min p-dgrey" }, [
                        _vm._v(
                          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque\n                                laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis\n                                et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit\n                                aspernatur aut odit aut f"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "saved" }, [
                      _c("p", { staticClass: "p-blue min-med p-bold" }, [
                        _vm._v("Saved 1200 kr/year by comparing")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "verify" }, [
                      _c("p", { staticClass: "p-green2 min" }, [
                        _vm._v("Verifierad köpare "),
                        _c("img", {
                          attrs: { src: "/img/icon/submit.svg", alt: "" }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "review-item" }, [
                    _c("div", { staticClass: "title-row" }, [
                      _c("div", { staticClass: "img" }, [
                        _c("img", { attrs: { src: "/img/image.png", alt: "" } })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "name" }, [
                        _c(
                          "p",
                          { staticClass: "max p-dgrey relawaySM  mb-0" },
                          [
                            _vm._v(
                              "\n                                   Peter Nordström\n                                "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "rating" }, [
                        _c("div", { staticClass: "star" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "star" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "star" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "star" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "star empty-star" })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _c("p", { staticClass: "min p-dgrey" }, [
                        _vm._v(
                          "But I must explain to you how all this mistaken idea of denouncing pleasure\n                                and praising pain was born and I will give you a complete account of the system,\n                                and expound the actual teachings of the great explorer of the truth, the master-builder of\n                                human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure,\n                                but because those who do not know how to pursue pleasure rationally encounter consequences\n                                that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain\n                                of itself, because it is p"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "saved" }, [
                      _c("p", { staticClass: "p-blue min-med  p-bold" }, [
                        _vm._v("Saved 1200 kr/year by comparing")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "verify" }, [
                      _c("p", { staticClass: "p-green2 min" }, [
                        _vm._v("Verifierad köpare "),
                        _c("img", {
                          attrs: { src: "/img/icon/submit.svg", alt: "" }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "review-item" }, [
                    _c("div", { staticClass: "title-row" }, [
                      _c("div", { staticClass: "name" }, [
                        _c("p", { staticClass: "max p-dgrey  mb-0" }, [
                          _c("b", [_vm._v("Peter Nordström")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "rating" }, [
                        _c("div", { staticClass: "star" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "star" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "star" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "star" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "star empty-star" })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _c("p", { staticClass: "min p-dgrey" }, [
                        _vm._v(
                          "Fakturabeloppet var ungefär hälften\n                                av vad jag förväntat mig. Positiv överraskning!!\n                                Jag är jättenöjd med servicen och leveransen."
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "saved" }, [
                      _c("p", { staticClass: "p-blue min-med  p-bold" }, [
                        _vm._v("Saved 1200 kr/year by comparing")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "verify" }, [
                      _c("p", { staticClass: "p-green2 min mb-0" }, [
                        _vm._v("Verifierad köpare "),
                        _c("img", {
                          attrs: { src: "/img/icon/submit.svg", alt: "" }
                        })
                      ])
                    ])
                  ])
                ]
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c(
        "h2",
        { staticClass: "h1 p-title p-black p-center mb-0 relawayBold" },
        [_vm._v("User reviews")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }